import React from 'react';
import { Box } from '@mui/material';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import {
  LenderRetailActivityCountryRowViewModel,
  LenderRetailActivityDeclineReasonRowViewModel,
} from '../../../api/types';
import { CreditDecisions } from './CreditDecisions';
import { DeclineReasonBreakdown } from './DeclineReasonBreakdown';

interface Props {
  byCountry: LenderRetailActivityCountryRowViewModel[];
  declineReasonRows: LenderRetailActivityDeclineReasonRowViewModel[];
  loading?: boolean;
  isDeclineReasonLoading?: boolean;
}

export const Declines = ({ byCountry, declineReasonRows, loading, isDeclineReasonLoading }: Props) => (
  <CardContainer title="Declines">
    <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
      <CreditDecisions rows={byCountry} loading={loading} />
      <DeclineReasonBreakdown rows={declineReasonRows} loading={isDeclineReasonLoading} />
    </Box>
  </CardContainer>
);
